import React from "react";
import "./famous.css";
import Navbar from "../components/Navbar";
import PageHeader from "../components/PageHeader";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';


const Famous = () => {
  return (
    <>
      <Navbar />
      <PageHeader title="Famous Personality" path="/famous" name="Famous Personality" />

      <div className="personality-container">
        {/* Row with Two Images */}
        <div className="image-row">
          <img src='https://etvbharatimages.akamaized.net/etvbharat/prod-images/768-512-16708091-815-16708091-1666335648897.jpg' alt="Shri Krishna Singh" className="image-small" />
          <img src='https://staticimg.amarujala.com/assets/images/2024/10/21/bihar-news-first-cm-of-bihar-dr-shri-krishna-singh-birth-anniversary-bihar-kesari_3ce4788cb99d1e25aff1997e2c2beca0.jpeg' alt="Shri Krishna Singh" className="image-small" />
        </div>

        {/* Main Content Section */}
        <div className="content-section">
          <div className="text-section">
            <h1>श्रीकृष्ण सिंह (श्रीकृष्ण बाबू) – बिहार के प्रथम मुख्यमंत्री</h1>

            <h2>प्रारंभिक जीवन और शिक्षा</h2>
            <p style={{color:'black'}}>
              श्रीकृष्ण सिंह, जिन्हें स्नेहपूर्वक "श्रीकृष्ण बाबू" कहा जाता है, का जन्म 
              21 अक्टूबर 1887 को बिहार के मुंगेर जिले के मऊ गाँव में हुआ था। वे बचपन से ही 
              मेधावी और समाज के प्रति जागरूक थे। उनकी प्रारंभिक शिक्षा गाँव में ही हुई, 
              जिसके बाद उन्होंने पटना विश्वविद्यालय से कानून की पढ़ाई की। इस दौरान वे 
              राष्ट्रवादी विचारधारा से प्रभावित हुए और भारत के स्वतंत्रता संग्राम में 
              शामिल होने का संकल्प लिया।
            </p>

            <h2>स्वतंत्रता संग्राम में भूमिका</h2>
            <p style={{color:'black'}}>
              श्रीकृष्ण सिंह भारतीय स्वतंत्रता संग्राम के प्रमुख नेताओं में से एक थे। 
              उन्होंने महात्मा गांधी के नेतृत्व में कई आंदोलनों में सक्रिय रूप से भाग लिया। 
              वे असहयोग आंदोलन (1920-22) और सविनय अवज्ञा आंदोलन (1930-34) में अग्रणी भूमिका 
              निभाते हुए जेल भी गए।
            </p>
            <ul>
              <li>ब्रिटिश शासन के विरुद्ध असहयोग आंदोलन में भाग लिया और जेल गए।</li>
              <li>बिहार में विदेशी वस्त्रों की होली जलाने वाले पहले नेताओं में से एक थे।</li>
              <li>1937 के चुनाव में कांग्रेस पार्टी की ओर से विजयी हुए और बिहार में पहली स्वशासी सरकार बनाई।</li>
              <li>भारत छोड़ो आंदोलन (1942) में ब्रिटिश सरकार के खिलाफ बड़ी भूमिका निभाई और कई महीनों तक जेल में रहे।</li>
            </ul>

            <h2>बिहार के प्रथम मुख्यमंत्री</h2>
            <p style={{color:'black'}}>
              भारत की स्वतंत्रता के बाद 1946 में उन्हें बिहार का पहला मुख्यमंत्री नियुक्त किया गया। 
              वे 1961 तक इस पद पर बने रहे, जो भारतीय राजनीति में किसी मुख्यमंत्री का एक उल्लेखनीय कार्यकाल था।
              उनकी सरकार ने राज्य में बुनियादी ढांचे के विकास, कृषि सुधारों और शिक्षा के क्षेत्र में 
              महत्वपूर्ण नीतियाँ लागू कीं।
            </p>

            <h2>मुख्यमंत्री के रूप में प्रमुख उपलब्धियाँ</h2>
            <ul>
              <li>
                <strong>शिक्षा सुधार:</strong> प्राथमिक शिक्षा को निःशुल्क और अनिवार्य बनाया। पटना विश्वविद्यालय 
                और अन्य शैक्षणिक संस्थानों को सशक्त किया।
              </li>
              <li>
                <strong>सामाजिक सुधार:</strong> जमींदारी प्रथा समाप्त की और दलितों तथा पिछड़े वर्गों के लिए 
                विशेष योजनाएँ लागू कीं।
              </li>
              <li>
                <strong>कृषि और उद्योग:</strong> बिहार में कृषि सुधार लागू किए, किसानों को नए तकनीकों से अवगत कराया 
                और औद्योगिकीकरण की नींव रखी।
              </li>
              <li>
                <strong>बुनियादी ढांचा विकास:</strong> सड़क, रेलवे, विद्युत और सिंचाई योजनाओं का विस्तार किया।
              </li>
            </ul>

            <h2>राजनीतिक दृष्टिकोण और नेतृत्व शैली</h2>
            <p style={{color:'black'}}>
              श्रीकृष्ण बाबू एक दूरदर्शी और निडर नेता थे। वे समाज के हर वर्ग को साथ लेकर चलने में विश्वास रखते थे। 
              उन्होंने प्रशासन में पारदर्शिता लाने और भ्रष्टाचार को रोकने के लिए कई कड़े कदम उठाए। उनके कार्यकाल 
              में बिहार में आर्थिक और सामाजिक विकास को प्राथमिकता दी गई।
            </p>

            <h2>श्रीकृष्ण बाबू की विरासत</h2>
            <p style={{color:'black'}}>
              श्रीकृष्ण सिंह को "आधुनिक बिहार के निर्माता" के रूप में जाना जाता है। उनकी दूरदर्शी नीतियों 
              ने बिहार को सामाजिक, आर्थिक और राजनीतिक रूप से सशक्त बनाने में महत्वपूर्ण भूमिका निभाई। 
              उनके सम्मान में बिहार में कई संस्थानों, सड़कों और भवनों का नाम रखा गया, जिनमें 
              पटना का श्रीकृष्ण मेमोरियल हॉल प्रमुख है।
            </p>
            <p style={{color:'black'}}>
              वे न केवल एक कुशल राजनेता थे, बल्कि समाज सुधारक भी थे। उन्होंने अपने जीवन का प्रत्येक क्षण 
              बिहार और देश के विकास के लिए समर्पित किया। आज भी उनके विचार और कार्य हमें प्रेरित करते हैं।
            </p>
          </div>

          {/* Main Image Section */}
        
        </div>
      </div>
                  <Footer />
                  <BackToTop />
    </>
  );
};

export default Famous;
